import { ProjectCreateStatusType } from "../../../repositories/model/support/ProjectCreateStatusType";

// TemplateProjectStates는 enum으로 변환할 수 없으므로 그대로 둡니다.
export const TemplateProjectStates = [
	{
		id: ProjectCreateStatusType.INFO,
		text: "과제 개요", // i18next.t("과제 개요"),
	},
	{
		id: ProjectCreateStatusType.EXAM,
		text: "문항 생성", // i18next.t("문항 생성"),
	},
	{
		id: ProjectCreateStatusType.RUBRIC,
		text: "평가 기준표", // i18next.t("평가 기준표"),
	}
];
